import { ComponentProps, FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { addDisplayName, addProps, flowMax } from 'ad-hok'

import { sansSerifFontFamily } from '../utils/styles'
import { Button } from './Button'

const useStyles = createUseStyles({
  textButton: {
    color: '#CDAA7E',
    letterSpacing: '0.1em',
    lineHeight: '140%',
    fontSize: '12px',
    fontWeight: 700,
    fontFamily: sansSerifFontFamily,
    fontStyle: 'normal',
  },
  disabled: {
    color: 'transparent',
  },
})

interface Props extends ComponentProps<typeof Button> {
  text: string
}

export const TextButton: FC<Props> = flowMax(
  addDisplayName('TextButton'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addProps(({ classes, disabled, className }) => ({
    buttonStyle: cx([
      classes.textButton,
      disabled && classes.disabled,
      className,
    ]),
  })),
  ({ buttonStyle, onClick, disabled, text }) => (
    <Button onClick={onClick} className={buttonStyle} disabled={disabled}>
      {text}
    </Button>
  )
)
